export default {
    readyable() {
        let resolve, reject;
        let promise = new Promise((r, j) => {
            resolve = r;
            reject = j;
        });
        promise.ready = resolve;
        promise.cancel = reject;
        return promise;
    },
    chooseFile(type) {
        return new Promise((r, j) => {
            let input = document.createElement("input");
            input.type = "file";
            input.accept = type;
            input.click();
            input.onchange = () => {
                r(input.files[0]);
            };
        });
    },
    relativeURL(path){
        const base = new URL(process.env.BASE_URL, location.href).toString()
        return new URL(path, base).toString()
    }
};
